import type { OnexData, OnexRaw } from "./index.js";
import * as mappers from "./mappers.js";
import type { NexusHandler } from "../nexus/function/function.types";

/**
 *
 */
export const getAssignments: NexusHandler<OnexRaw["getAssignments"]> = () =>
  new Promise<OnexData>((resolve) => {
    const unsub = otto.onex.assignments.sub((v) => {
      if (v) {
        resolve(v);
        unsub();
      }
    });
  });

/**
 *
 */
export const isOnexVariant: NexusHandler<OnexRaw["isOnexVariant"]> = async (...args) =>
  mappers.isOnexVariant.call(mappers.customAssignments(await getAssignments()), ...args);

/**
 *
 */
export const mapOnexVariant: NexusHandler<OnexRaw["mapOnexVariant"]> = async (...args) =>
  mappers.mapOnexVariant.call(
    mappers.customAssignments(await getAssignments()),
    ...(args as unknown as Parameters<typeof mappers.mapOnexVariant>),
  );
